class CartSelection {
  constructor() {
    this.storageKey = 'shopify_saved_for_later';
    this.deleteIcon = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 0.5H11.5V3.65217C11.5 3.6619 11.4997 3.67156 11.4992 3.68115H15C15.2761 3.68115 15.5 3.90501 15.5 4.18115C15.5 4.45729 15.2761 4.68115 15 4.68115H1C0.723858 4.68115 0.5 4.45729 0.5 4.18115C0.5 3.90501 0.723858 3.68115 1 3.68115H4.50083C4.50028 3.67156 4.5 3.6619 4.5 3.65217V0.5ZM5.49917 3.68115H10.5008C10.5003 3.67156 10.5 3.6619 10.5 3.65217V1.5H5.5V3.65217C5.5 3.6619 5.49972 3.67156 5.49917 3.68115ZM2 5.58696C2.27614 5.58696 2.5 5.81081 2.5 6.08696V13.1739C2.5 13.3997 2.57082 13.7484 2.76775 14.0258C2.94632 14.2774 3.24601 14.5 3.8 14.5H12.2C12.4185 14.5 12.7586 14.4293 13.0301 14.231C13.2765 14.051 13.5 13.7444 13.5 13.1739V6.08696C13.5 5.81081 13.7239 5.58696 14 5.58696C14.2761 5.58696 14.5 5.81081 14.5 6.08696V13.1739C14.5 14.0643 14.1235 14.6707 13.6199 15.0385C13.1414 15.3881 12.5815 15.5 12.2 15.5H3.8C2.91399 15.5 2.31368 15.1139 1.95225 14.6046C1.60918 14.1212 1.5 13.5568 1.5 13.1739V6.08696C1.5 5.81081 1.72386 5.58696 2 5.58696Z" fill="#292929"></path>
</svg>`;
    this.init();
  }

  init() {
    this.renderSavedItems();
    this.bindEvents();
  }

  getSavedItems() {
    const items = localStorage.getItem(this.storageKey);
    return items ? JSON.parse(items) : [];
  }

  saveItem(item) {
    const items = this.getSavedItems();
    // Check if valid item
    if (!item.id) return;
    
    // Check duplicates
    if (!items.find(i => i.id === item.id)) {
      items.push(item);
      localStorage.setItem(this.storageKey, JSON.stringify(items));
    }
  }

  removeItem(variantId) {
    let items = this.getSavedItems();
    items = items.filter(i => i.id !== variantId);
    localStorage.setItem(this.storageKey, JSON.stringify(items));
  }

  bindEvents() {
    // Delegated events for Cart Checkboxes (handles dynamic re-rendering)
    document.body.addEventListener('change', (e) => {
      if (e.target.classList.contains('cart-select-checkbox')) {
        if (!e.target.checked) {
          this.handleMoveToSaved(e.target);
        }
      }
    });

    // Delegated events for Saved Items (Main Cart & Drawer)
    document.body.addEventListener('change', (e) => {
      if (e.target.classList.contains('saved-item-checkbox') && e.target.checked) {
        this.handleMoveToCart(e.target);
      }
    });

    document.body.addEventListener('click', (e) => {
      if (e.target.classList.contains('move-to-cart-btn')) {
        e.preventDefault();
        const variantId = e.target.dataset.variantId;
        
        // Robustly find the checkbox. 
        // 1. Try finding in the same container first
        let checkbox = null;
        const container = e.target.closest('ul');
        if (container) {
           checkbox = container.querySelector(`.saved-item-checkbox[data-variant-id="${variantId}"]`);
        }
        
        // 2. If not found (e.g. strict ID scoping or structure changed), search document-wide
        // We prioritize the one closest to the clicked button if possible, but IDs are unique per item anyway usually.
        if (!checkbox) {
           checkbox = document.querySelector(`.saved-item-checkbox[data-variant-id="${variantId}"]`);
        }
        
        if (checkbox) {
          checkbox.checked = true;
          // Trigger change event manually if needed, or just call handler directly
          this.handleMoveToCart(checkbox);
        } else {
             console.warn('Checkbox not found for variant', variantId);
             // Fallback: try to execute move without checkbox visual update using ghost element logic?
             // No, let's just create a dummy object if absolutely needed, but checkbox SHOULD exist if rendered.
        }
      }

      // Remove from Saved For Later
      const removeBtn = e.target.closest('.remove-saved-item');
      if (removeBtn) {
        e.preventDefault();
        const variantId = parseInt(removeBtn.dataset.variantId);
        this.handleRemoveFromSaved(variantId, removeBtn);
      }
    });
  }

  handleRemoveFromSaved(variantId, button) {
    const row = button.closest('.cart-item-container') || button.closest('.cart-summary__product');
    if (row) row.style.opacity = '0.5';

    this.removeItem(variantId);
    
    // Refresh the UI
    this.renderSavedItems();
    this.renderSavedItemsInDrawer();
  }

  async handleMoveToSaved(checkbox) {
    const row = checkbox.closest('.cart-item-container') || checkbox.closest('.cart-summary__product');
    const variantId = parseInt(checkbox.dataset.variantId);
    const lineIndex = parseInt(checkbox.dataset.lineIndex);
    const quantity = parseInt(checkbox.dataset.quantity);

    const itemData = {
      id: variantId,
      quantity: quantity,
      title: checkbox.dataset.title,
      image: checkbox.dataset.image,
      price: checkbox.dataset.price,
      url: checkbox.dataset.url,
      options: checkbox.dataset.options
    };

    if(row) row.style.opacity = '0.5';
    
    this.saveItem(itemData);

    try {
      await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          line: lineIndex,
          quantity: 0
        })
      });
      
      this.refreshCartDrawer();
    } catch (error) {
      console.error('Error removing item:', error);
      if(row) row.style.opacity = '1';
      checkbox.checked = true;
    }
  }

  // Helper to retrieve specific item data
  getSavedItem(variantId) {
    const items = this.getSavedItems();
    return items.find(i => i.id === variantId);
  }

  async handleMoveToCart(checkbox) {
    const row = checkbox.closest('.saved-item-container') || checkbox.closest('.cart-summary__product');
    const variantId = parseInt(checkbox.dataset.variantId);
    
    const savedItem = this.getSavedItem(variantId);
    const quantityToAdd = savedItem ? savedItem.quantity : 1;

    if(row) row.style.opacity = '0.5';

    try {
      await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: quantityToAdd
          }]
        })
      });

      this.removeItem(variantId);
      this.refreshCartDrawer();
    } catch (error) {
      console.error('Error adding item:', error);
      if(row) row.style.opacity = '1';
      checkbox.checked = false;
    }
  }

  async refreshCartDrawer() {
    // 1. Fetch updated header section
    try {
      const response = await fetch('/?section_id=header');
      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');
      
      // 2. Select specific elements to update to avoid replacing the wrapper (which closes the drawer)
      const newProductList = doc.querySelector('.cart-summary__product-list');
      const newFooter = doc.querySelector('.cart-summary__footer');
      const newCount = doc.querySelector('.header-cart__count');
      
      const currentProductList = document.querySelector('.cart-summary__product-list');
      const currentFooter = document.querySelector('.cart-summary__footer');
      const currentCount = document.querySelector('.header-cart__count');
      
      // Update Count
      if (newCount && currentCount) {
        currentCount.innerHTML = newCount.innerHTML;
      }
      
      // Update Product List
      if (newProductList && currentProductList) {
        currentProductList.innerHTML = newProductList.innerHTML;
      } else if (newProductList && !currentProductList) {
         // If list didn't exist (e.g. empty cart), we might need to recreate the summary structure?
         // For now, assume structure exists. If empty cart, liquid might not render 'cart-summary'.
         // If we moved item to saved and cart is now empty, 'newProductList' might be null.
         // But we want to KEEP the saved items visible.
         // If newProductList is null, it means cart is empty.
         // We should clear the current list (except saved items if we want to handle that manually, 
         // but our Saved Logic injects into a specific ID).
         if (currentProductList) currentProductList.innerHTML = ''; 
      }

      // Update Footer
      if (newFooter && currentFooter) {
        // If cart is empty, new footer might not exist or be empty.
        currentFooter.innerHTML = newFooter.innerHTML;
      }

      // If the cart was completely empty (no .cart-summary), we might lose the container.
      // But we are only updating innerHTML of existing containers.
      // If the containers don't exist in the current page, we can't update them.
      
      // 3. Re-render Saved Items (both places)
      this.renderSavedItems();
      this.renderSavedItemsInDrawer();

      // 4. Force style to keep drawer open/visible if it was hovered?
      // Since we didn't replace the parent .header-cart, the hover state should remain active 
      // as long as the mouse is over it.
      
      // 5. Also reload main page if we are on cart page to keep in sync
      if (window.location.pathname.includes('/cart')) {
        window.location.reload();
      }

    } catch (e) {
      console.error('Error refreshing cart:', e);
      // Fallback only if critical failure
       if (window.location.pathname.includes('/cart')) {
        window.location.reload();
      }
    }
  }

  renderSavedItems() {
    // Main Cart Page Render
    const container = document.getElementById('saved-for-later-container');
    const list = document.getElementById('saved-for-later-list');
    
    // Drawer Render
    this.renderSavedItemsInDrawer();

    if (!container || !list) return;

    const items = this.getSavedItems();

    if (items.length === 0) {
      container.style.display = 'none';
      return;
    }

    container.style.display = 'block';

    // Helper to format options
    const formatOptions = (optionsStr) => {
      if (!optionsStr) return '';
      let formatted = optionsStr;
      if (formatted.includes('Size: ST')) {
        formatted = formatted.replace('Size: ST', 'Size: One Size - Fits All');
      }
      return formatted.split(',').map(opt => {
        const parts = opt.split(':');
        if (parts.length >= 2) {
            const label = parts[0].trim();
            const value = parts.slice(1).join(':').trim();
            return `<p class="description__variant">${label} : ${value}</p>`;
        }
        return `<p class="description__variant">${opt}</p>`;
      }).join('');
    };

    list.innerHTML = items.map(item => `
      <li class="cart-item-container">
        <div class="cart-checkbox-wrapper">
          <input type="checkbox" class="saved-item-checkbox" data-variant-id="${item.id}">
        </div>
        <a class="cart-mobile-image" href="${item.url}">
          <img class="global-border-radius" src="${item.image}" alt="${item.title}">
        </a>
        <div class="cart-item flex">
            <div class="image">
              <a class="block global-border-radius hover-images" href="${item.url}">
                <img class="image-one" src="${item.image}" alt="${item.title}">
              </a>
            </div>
          <div class="description">
            <a class="description__title" href="${item.url}">
              ${item.title.split('"')[1] || item.title}
            </a>
            
             ${formatOptions(item.options)}
            
            <button class="btn btn--secondary btn--small move-to-cart-btn" data-variant-id="${item.id}" style="margin-top: 10px;">
              Move to Cart
            </button>
          </div>

          <div class="price center">
            <div class="price_div">
              <div class="theme-money">${item.price}</div>
            </div>
            <div class="qty_select">
                 Qty: ${item.quantity}
            </div>
            <div class="remove_btn">
              <a class="quantity__remove remove-saved-item" data-variant-id="${item.id}" href="#">
                <span class="quantity__remove-x icon feather-icon">${this.deleteIcon}</span>
              </a>
            </div>
          </div>
        </div>
      </li>
    `).join('');
  }

  renderSavedItemsInDrawer() {
    // We want to render inside '.cart-summary__product-list' but at the bottom.
    // If we just rely on ID 'saved-for-later-drawer-container', it might be gone after refresh 
    // IF the refresh logic replaced internal HTML containing it. 
    // Our refresh logic now replaces `cart-summary__product-list` innerHTML.
    // So the container IS inside the replaced content (because we moved it there in Liquid).
    // So if the new HTML from fetch includes the container, we are good.
    // If the new HTML (from empty cart or partial cart) includes it, we just need to find it again.
    
    // However, if the cart items are empty, the Liquid might NOT render the product list loop, 
    // so the container might NOT be in the fetched HTML.
    // So we should check if container exists. If not, we might need to append it.
    
    const productList = document.querySelector('.cart-summary__product-list');
    if (!productList) return;

    let container = document.getElementById('saved-for-later-drawer-container');
    
    // If container doesn't exist (e.g. wiped by refresh or not in Liquid because cart empty), create it
    if (!container) {
       container = document.createElement('div');
       container.id = 'saved-for-later-drawer-container';
       container.style.cssText = 'display: none; border-top: 1px solid #eee; padding-top: 15px; margin-top: 15px;';
       container.innerHTML = `<div class="h5">Saved for Later</div><ul id="saved-for-later-drawer-list" class="saved-items-grid--drawer"></ul>`;
       productList.appendChild(container);
    }

    const list = document.getElementById('saved-for-later-drawer-list');
    if (!list) return;

    const items = this.getSavedItems();

    if (items.length === 0) {
      container.style.display = 'none';
      return;
    }

    container.style.display = 'block';
    
    // Helper to format options
    const formatOptions = (optionsStr) => {
      // Input like: "Size: ST, Color: Red"
      // We want to replace "Size: ST" with "Size: One Size - Fits All"
      if (!optionsStr) return '';
      let formatted = optionsStr;
      if (formatted.includes('Size: ST')) {
        formatted = formatted.replace('Size: ST', 'Size: One Size - Fits All');
        // Handle if "ST" matches but maybe we should be careful. 
        // The user said "ST" specifically.
      }
      
      // Convert comma separated string to HTML structure similar to drawer
      // Drawer uses: <div class="added-notice__variant"><span class="label">Name:</span> <span class="value">Value</span></div>
      // But our saved string is just text. Let's try to parse or just display nicely.
      // Since it's a simple display update, let's keep it as text but wrapped nicely.
      // Or better, split by comma and wrap.
      
      return formatted.split(',').map(opt => {
        const parts = opt.split(':');
        if (parts.length >= 2) {
            const label = parts[0].trim();
            const value = parts.slice(1).join(':').trim();
            return `<div class="added-notice__variant"><span class="added-notice__variant-label">${label}:</span> <span class="added-notice__variant-value">${value}</span></div>`;
        }
        return `<div>${opt}</div>`;
      }).join('');
    };

    list.innerHTML = items.map(item => `
      <div class="cart-summary__product">
        <div class="saved-checkbox-wrapper">
          <input type="checkbox" class="saved-item-checkbox" data-variant-id="${item.id}">
        </div>
        <div class="cart-summary__product-image">
           <img class="responsive-image__image" src="${item.image}" alt="${item.title}">
        </div>
        <div class="cart-summary__product__description">
          <div class="cart-summary__product-title">
             <a href="${item.url}">${item.title}</a>
          </div>
          <div class="cart-summary__product__variants">
             ${formatOptions(item.options)}
          </div>
          <div class="cart-summary__price">
             <span class="theme-money">${item.price}</span>
          </div>
          <button class="btn btn--secondary btn--small move-to-cart-btn" data-variant-id="${item.id}">
            Move to Cart
          </button>
        </div>
      </div>
    `).join('');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CartSelection();
});
